'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactContextmenu = require('react-contextmenu');

var _lodash = require('lodash');

var _Button = require('../elements/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ContextMenu = function ContextMenu(_ref) {
  var id = _ref.id,
      items = _ref.items,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['id', 'items', 'className', 'children']);

  return React.createElement(
    'div',
    { className: 'ContextMenu' },
    React.createElement(
      _reactContextmenu.ContextMenu,
      { id: id },
      items ? renderItems(items) : children
    )
  );
};

var renderItems = function renderItems(items) {
  return (0, _lodash.map)(items, function (item, key) {
    return (0, _lodash.isFunction)(item) ? React.createElement(
      ContextMenu.Item,
      { key: key, onClick: item },
      key
    ) : React.createElement(ContextMenu.SubMenu, { items: item, key: key, title: key, icon: '>' });
  });
};

var MenuButton = function (_React$Component) {
  _inherits(MenuButton, _React$Component);

  function MenuButton() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, MenuButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = MenuButton.__proto__ || Object.getPrototypeOf(MenuButton)).call.apply(_ref2, [this].concat(args))), _this), _this.id = 'menubutton-' + Math.random().toString(36), _this.handleClick = function (e) {
      return _this.trigger && _this.trigger.handleContextClick && _this.trigger.handleContextClick(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MenuButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          label = _props.label,
          variant = _props.variant,
          props = _objectWithoutProperties(_props, ['label', 'variant']);

      return React.createElement(
        'div',
        { className: 'ButtonMenu' },
        React.createElement(_reactContextmenu.ContextMenuTrigger, {
          ref: function ref(trigger) {
            return _this2.trigger = trigger;
          },
          id: this.id,
          children: ''
        }),
        React.createElement(
          _Button2.default,
          { onClick: this.handleClick, variant: variant },
          label
        ),
        React.createElement(
          'div',
          { className: 'menu-positioner' },
          React.createElement(ContextMenu, _extends({}, props, { id: this.id }))
        )
      );
    }
  }]);

  return MenuButton;
}(React.Component);

var SubMenu = function SubMenu(_ref3) {
  var title = _ref3.title,
      _ref3$icon = _ref3.icon,
      icon = _ref3$icon === undefined ? '►' : _ref3$icon,
      props = _objectWithoutProperties(_ref3, ['title', 'icon']);

  return React.createElement(_reactContextmenu.SubMenu, _extends({
    title: React.createElement(
      'span',
      { className: 'title' },
      title,
      React.createElement(
        'span',
        { className: 'submenu-indicator' },
        icon
      )
    )
  }, props));
};
var Trigger = function Trigger(_ref4) {
  var _ref4$as = _ref4.as,
      as = _ref4$as === undefined ? 'div' : _ref4$as,
      props = _objectWithoutProperties(_ref4, ['as']);

  return React.createElement(_reactContextmenu.ContextMenuTrigger, _extends({ renderTag: as }, props));
};
ContextMenu.Item = _reactContextmenu.MenuItem;
ContextMenu.SubMenu = SubMenu;
ContextMenu.Trigger = Trigger;
ContextMenu.MenuButton = MenuButton;
exports.default = ContextMenu;